/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var keys          = require('stb-keys'),
    app           = require('mag-app'),

    Page          = require('stb-component-page'),
    Grid          = require('../components/grid'),

    metrics       = require('../metrics'),
    listSize      = metrics[screen.height] ? metrics[screen.height].listSize : metrics[720].listSize,
    // listSmallSize = metrics[screen.height] ? metrics[screen.height].listSmallSize : metrics[720].listSmallSize,

    page          = new Page({$node: document.getElementById('pageMain')}),

    $pageMainFooter = document.getElementById('pageMainFooter'),
    $pageMainArrowLeft = document.getElementById('pageMainArrowLeft'),
    $pageMainArrowRight = document.getElementById('pageMainArrowRight'),

    lastIntent    = null,
    stopKeydown   = false,
    appList;


appList = new Grid({
    $node: document.getElementById('pageMainAppList'),
    className: 'app-list',
    cycleX: false,
    cycleY: false,
    sizeX: listSize,
    sizeY: 1,
    provider: require('../modules/app.data.provider'),
    render: function ( $item, data ) {
        if ( !$item.ready ) {
            $item.$body = document.createElement('div');
            $item.$normal = document.createElement('div');
            $item.$active = document.createElement('div');
            $item.$activeCloseIcon = document.createElement('div');
            $item.$activeContent = document.createElement('div');
            $item.$normalContent = document.createElement('div');
            $item.$activeContent = document.createElement('div');
            $item.$normalIcon = document.createElement('div');
            $item.$activeIcon = document.createElement('div');
            $item.$normalName = document.createElement('div');
            $item.$activeName = document.createElement('div');
            $item.$normalLock = document.createElement('div');
            $item.$activeLock = document.createElement('div');
            $item.$normalGradientOverlay = document.createElement('div');
            $item.$activeGradientOverlay = document.createElement('div');

            $item.className = 'app';
            $item.$body.className = 'app__body';
            $item.$normal.className = 'app__normal';
            $item.$active.className = 'app__active';
            $item.$activeCloseIcon.className = 'app__icon close';
            $item.$normalContent.className = 'app__content';
            $item.$activeContent.className = 'app__content';
            $item.$normalLock.className = 'app__locked';
            $item.$activeLock.className = 'app__locked';
            $item.$normalName.className = 'app__name';
            $item.$activeName.className = 'app__name';
            $item.$normalIcon.className = 'app__icon';
            $item.$activeIcon.className = 'app__icon';
            $item.$normalGradientOverlay.className = 'app__overlay';
            $item.$activeGradientOverlay.className = 'app__overlay';

            $item.$normalContent.appendChild($item.$normalIcon);
            $item.$normalContent.appendChild($item.$normalName);
            $item.$normalContent.appendChild($item.$normalLock);
            $item.$activeContent.appendChild($item.$activeIcon);
            $item.$activeContent.appendChild($item.$activeName);
            $item.$activeContent.appendChild($item.$activeLock);

            $item.$normal.appendChild($item.$normalContent);
            $item.$normal.appendChild($item.$normalGradientOverlay);
            $item.$active.appendChild($item.$activeCloseIcon);
            $item.$active.appendChild($item.$activeContent);
            $item.$active.appendChild($item.$activeGradientOverlay);

            $item.$body.appendChild($item.$normal);
            $item.$body.appendChild($item.$active);

            $item.appendChild($item.$body);

            $item.ready = true;
        }

        if ( data.config.locked ) {
            $item.$normalLock.style.visibility = $item.$activeLock.style.visibility = 'inherit';
        } else {
            $item.$normalLock.style.visibility = $item.$activeLock.style.visibility = 'hidden';
        }

        if ( data.disable ) {
            $item.classList.add('disable');
            $item.$activeCloseIcon.style.backgroundImage =
                $item.$activeIcon.style.backgroundImage = $item.$normalIcon.style.backgroundImage = 'none';
            $item.$normalName.innerText = $item.$activeName.innerText = '';
            $item.$normalContent.style.backgroundColor = $item.$activeContent.style.backgroundColor = 'transparent';
        } else {
            //console.log(' render ' + data.config.name);
            $item.$normalName.innerText = $item.$activeName.innerText = data.config.name;
            $item.$normalName.style.color = $item.$activeName.style.color = data.config.colors.splashFont;
            $item.$normalContent.style.backgroundColor = $item.$activeContent.style.backgroundColor = data.config.colors.splashBackground;
            $item.$normalIcon.style.backgroundImage = 'url("' + data.config.uris.icons.logoNormal + '")';
            $item.$activeIcon.style.backgroundImage = 'url("' + data.config.uris.icons.logoActive + '")';
            $item.$activeCloseIcon.style.backgroundImage = '';
            $item.classList.remove('disable');
        }
    },
    events: {
        'data:ready': function ( direction ) {
            if ( page.active ) {
                this.focus();

                if ( direction && direction === keys.right ) {
                    this.focusItem(this.map[0][5]);
                } else {
                    this.focusItem(this.map[0][0]);
                }
            }
        },
        'click:item': function ( event ) {
            console.log('CLICK ITEM');

            if ( !event.$item.data.disable ) {
                core.taskManager.osdStack.forEach(function ( osd ) {
                    if ( osd.$iframe.src !== location.href ) {
                        osd.core.emit('hide', {source: core.sources.system});
                    }
                });

                core.taskManager.runApp({
                    config: event.$item.data.config,
                    visible: true,
                    onload: function () {
                        console.log('ONLOAD');

                        core.call('hide');
                        core.call('blur');

                        if ( lastIntent ) {
                            lastIntent.emit('block', false);
                        }
                    }
                });
            }
        }
    }
});


function showDescription () {
    $pageMainArrowLeft.style.visibility = '';
    $pageMainArrowRight.style.visibility = '';
    $pageMainFooter.style.display = '';
}


function showNoAppsNotification () {
    appList.$body.innerHTML = '<span>' + gettext('No apps') + '</span>';
    $pageMainArrowLeft.style.visibility = 'hidden';
    $pageMainArrowRight.style.visibility = 'hidden';
    $pageMainFooter.style.display = 'none';
}


function renderApps () {
    var refresh = false;

    if ( appList.provider.pageSize !== listSize ) {
        refresh = true;
        appList.provider.pageSize = listSize;
        appList.sizeX = listSize;
    }

    if ( refresh ) {
        appList.init({
            sizeX: appList.sizeX,
            sizeY: appList.sizeY,
            provider: appList.provider
        });

        showDescription();

        appList.focus();
    } else if ( core.taskManager.runHistory.length > 0 ) {
        appList.focus();

        appList.$body.innerHTML = '';
        showDescription();

        appList.$body.appendChild(appList.$table);

        appList.provider.get(null, function ( error, data ) {
            var xPos, yPos;

            if ( error ) {
                if ( appList.events['data:error'] ) {
                    /**
                     * Provider get error while take new data
                     *
                     * @event module:stb/ui/grid~Grid#data:error
                     */
                    appList.emit('data:error', error);
                }

                return;
            }

            if ( data ) {
                appList.data = appList.translate(data);

                for ( xPos = 0; xPos < appList.sizeY; xPos++ ) {
                    for ( yPos = 0; yPos < appList.sizeX; yPos++ ) {
                        appList.map[xPos][yPos].data = appList.data[xPos][yPos];
                        appList.renderItem(appList.map[xPos][yPos], appList.data[xPos][yPos]);
                    }
                }

                if ( appList.events['data:ready'] ) {
                    /**
                     * Provider get new data and reinit grid
                     *
                     * @event module:stb/ui/grid~Grid#data:ready
                     */
                    appList.emit('data:ready');
                }
            }
        });
    } else {
        appList.blur();

        showNoAppsNotification();
    }
}

core.addListener('keydown:' + keys.app, function () {
    console.log(core.applicationState.visible);

    if ( core.applicationState.visible ) {
        core.call('hide');
        core.call('blur');

        if ( lastIntent ) {
            lastIntent.emit('close');
            lastIntent = null;
        }
    } else {
        lastIntent = null;

        if ( lastIntent ) {
            lastIntent = null;
        }

        renderApps();

        core.call('show');
        core.call('focus');
    }
});

core.addListener('hide', function () {
    console.log('HIDE FROM CORE, app.visible: ' + core.applicationState.visible);

    core.call('hide');

    if ( lastIntent ) {
        lastIntent.emit('close');
        lastIntent = null;
    }
});

core.addListener('intent', function ( intent ) {
    if ( intent.action === 'taskmanager:show' ) {
        if ( lastIntent ) {
            lastIntent = null;
        }

        renderApps();

        core.call('show');
        core.call('focus');

        lastIntent = intent;

        intent.once('close', function () {
            lastIntent = null;
        });
    }
});

appList.addListener('keydown', function ( event ) {
    var pid;

    if ( stopKeydown ) {
        return;
    }

    if ( event.code === keys.up ) {
        stopKeydown = true;

        if ( core.taskManager.runHistory.length === 1 ) {
            pid = appList.$focusItem.data.config.pid;

            core.call('hide');
            core.call('blur');

            core.taskManager.close(core.taskManager.apps[pid]);
            pid = core.taskManager.runHistory.indexOf(appList.$focusItem.data.config);
            core.taskManager.runHistory.splice(pid, 1);

            if ( lastIntent ) {
                lastIntent.emit('block', false);
            }
        } else if ( !core.taskManager.topApp ) {
            // in launcher
            pid = appList.$focusItem.data.config.pid;
            core.taskManager.close(core.taskManager.apps[pid], true);

            pid = core.taskManager.runHistory.indexOf(appList.$focusItem.data.config);
            core.taskManager.runHistory.splice(pid, 1);

            core.call('show');
            core.call('focus');
        } else if ( core.taskManager.runHistory.length > 0 ) {
            pid = appList.$focusItem.data.config.pid;
            core.taskManager.close(core.taskManager.apps[pid]);

            pid = core.taskManager.runHistory.indexOf(appList.$focusItem.data.config);
            core.taskManager.runHistory.splice(pid, 1);

            core.taskManager.runApp({
                config: core.taskManager.runHistory.pop(),
                visible: true,
                onready: function () {
                    setTimeout(function () {
                        core.call('show');
                        core.call('focus');
                    }, 0);
                }
            });
        }

        renderApps();

        stopKeydown = false;
    }
});

app.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        core.call('hide');
        core.call('blur');

        lastIntent.emit('close');
        lastIntent = null;
    }
});

page.addListener('keydown', function ( localEvent, event ) {
    if ( localEvent.code === 0 ) {
        return;
    }

    if ( page.activeComponent === null ) {
        switch ( localEvent.code ) {
            case keys.app:
            case keys.exit:
            case keys.volumeUp:
            case keys.volumeDown:
                return;
        }

        if ( event.ctrlKey || event.altKey || event.shiftKey ) {
            return;
        }

        core.call('hide');
        core.call('blur');
    }
});

showNoAppsNotification();
document.getElementById('pageMainFooterLabel').innerText = gettext('Press OK to open or Up to close application');

page.add(appList);
page.once('show', function () {
    renderApps();
});

// public
module.exports = page;
